GameView   = require("views/base/game")
seqTempl   = require("./components/sequence")
optTempl   = require("./components/options")
Preloader  = require("lib/preload")

class GameNextInOrderView extends GameView
  template: require("./template")

  events: ->
    "iostap .play-game": "enterGame"
    "iostap .goto-next": "next"
    "iostap .btn-image": "checkAnswer"

  initializeData: ->
    super

    @game.extra.set("fullscreen", true)
    @game.extra.set("sounds", true)

    { imposters, sequence } = @options.data

    for key, arr of { imposters, sequence }
      arr = _.compact(arr)
      arr = _.filter(arr, _.isString)
      @setArray key, arr

      Preloader.load arr, (errors = []) =>
        @setArray key, _.without(arr, errors...)

  initializeElements: ->
    super

    @setEl @findOne(".game-box"), "container"
    @setEl @findOne(".next-sequence"), "sequence"
    @setEl @findOne(".next-options"), "options"

  startGame: ->
    @game.timer.timestamp = Date.now()
    super

  showNext: ->
    @setArray "missing",
      _.chain([0...@getArray("sequence").length])
        .sample(@getDifficulty())
        .sortBy(_.identity)
        .value()

    @continueSequence(true)

  continueSequence: (isFirstRun) ->
    @game.timer.timestamp = Date.now()

    data = _.extend {}, @options.data,
      missing: @getArray("missing")
      options: _
        .chain(@getArray("missing").slice(1))
        .map((i) => @getArray("sequence")[i])
        .concat(@getArray("imposters"))
        .sample(3)
        .concat(@getArray("sequence")[@getArray("missing")[0]])
        .shuffle()
        .value()

    @getEl("options").innerHTML = optTempl data

    seqEl = @getEl("sequence")
    if isFirstRun
      @getEl("container").classList.remove("hidden")
      seqEl.innerHTML = seqTempl data
      seqEl.style.width =
          @getArray("sequence").length * seqEl.firstChild.offsetWidth + "px"

    if seqEl.querySelectorAll(".hidden").item(0)
      el = seqEl.querySelectorAll(".hidden").item(0)
      x  = (-el.parentNode.offsetLeft - seqEl.offsetLeft) -
          (el.parentNode.offsetWidth - seqEl.parentNode.offsetWidth) / 2
    else
      return

    el.classList.add("hidden-next")

    @transform @getEl("sequence"),
      x: x
      transition: "all 300ms"

    @setArray "missing", @getArray("missing").slice(1)

    @getEl("container").offsetTop
    @getEl("container").classList.remove("hidden", "between")

  checkAnswer: (e) ->
    el = @findOne(".hidden-next")

    return if @game.timer.get("paused") or not el?

    { isCorrect } = e.currentTarget.dataset
    isComplete    = @getArray("missing").length is 0

    if isCorrect?
      @onCorrectAnswer
        score: if isComplete then 1000 else 200
        time:  if isComplete then 3000 else 500
        tally: true

    else
      @onIncorrectAnswer
        time: 1000
        tally: true

    el.classList.remove("hidden", "hidden-next")

    if isComplete or not isCorrect?
      window.setTimeout (=>
        if @game.timer.get("isDisabled")
          @endGame()
          return

        @getEl("container").classList.add("hidden")
        window.setTimeout (=> @showNext()), 800
      ), 500
    else
      @getEl("container").classList.add("between")
      window.setTimeout (=> @continueSequence()), 800

  getDifficulty: ->
    if @game.timer.get("isDisabled")
      @getArray("sequence").length
    else
      consecutive = @game.score.get("consecutive")
      Math.floor _.limit((consecutive + 1) / 2, @getArray("sequence").length, 2)


module.exports = GameNextInOrderView
